import qzTraySignatureApi from "../../api/qztray/qzTraySignatureApi";

/**
 * ✍️ QzTraySignerService
 *
 * Gestiona la firma digital y la verificación de datos
 * usando los certificados activos de QZ Tray.
 *
 * ✅ Endpoints:
 * - POST /api/qztray/sign
 * - POST /api/qztray/verify
 */
const QzTraySignerService = {
  /**
   * ✍️ Firmar un payload usando un certificado activo.
   * @param payload Contenido (JSON o texto) a firmar.
   * @param certificateType Tipo de certificado a utilizar (PEM_KEY, P12, etc.)
   */
  signPayload: async (payload: object, certificateType: string) => {
    const response = await qzTraySignatureApi.addCustom("/sign", {
      payload,
      certificateType,
    });
    return response.data;
  },

  /**
   * ✅ Verificar si una firma digital corresponde al payload original.
   * @param payload Contenido original firmado.
   * @param signature Firma digital en Base64.
   * @param certificateType Tipo de certificado que generó la firma.
   */
  verifySignature: async (
    payload: object,
    signature: string,
    certificateType: string
  ) => {
    const response = await qzTraySignatureApi.addCustom("/verify", {
      payload,
      signature,
      certificateType,
    });
    return response.data;
  },
};

export default QzTraySignerService;
